import { render, staticRenderFns } from "./Protectiondetails.vue?vue&type=template&id=1825f258&scoped=true&"
import script from "./Protectiondetails.vue?vue&type=script&lang=js&"
export * from "./Protectiondetails.vue?vue&type=script&lang=js&"
import style0 from "./Protectiondetails.vue?vue&type=style&index=0&id=1825f258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825f258",
  null
  
)

export default component.exports